/**
 * Removes the query string from a URL.
 */
export function removeQueryString(url: string) {
  const [path] = url.split('?');

  return path;
}
